<script setup lang="ts">
import ProgressFrame from './layout/ProgressFrame.vue';
import VisualFailure from '../components/VisualFailure.vue';
import ButtonOutlined from '@/shared/components/button/ButtonOutlined.vue';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import router from '@/router';
import { useCommissioningNavStore } from '../stores/commissioningNavStore';
import { useCommissioningDeviceStore } from '../stores/commissioningDeviceStore';

const commissioningNavStore = useCommissioningNavStore();
const commissioningDeviceStore = useCommissioningDeviceStore();
const serialNumber = commissioningDeviceStore.serialNumber;

const onTryAgain = () => {
  router.replace({ name: 'SerialNumberHow' });
};

const onContactSupport = () => {
  commissioningNavStore.requestContactUsViaNavBar();
};
</script>

<template>
  <ProgressFrame pageClass="subsection-page">
    
    <div class="page-failure-container">
      <VisualFailure>
        <template #title>You don't have access to recommission this SolShare</template>
      </VisualFailure>
      <p class="subtitle">{{ serialNumber }}</p>
      <p>Only installers with access to this SolShare or project can perform a recommission. Contact Allume if you need access.</p>
    </div>
    <div class="end-of-page">
      <ButtonOutlined block @click="onTryAgain" data-tn="try-again-btn">Let's try again</ButtonOutlined>
      <ButtonPrimary block @click="onContactSupport" data-tn="contact-support-btn">Contact Support</ButtonPrimary>
    </div>
  </ProgressFrame>
</template>

<style lang="less" scoped>
.page-failure-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: @content-side-margin;
}
.subtitle {
  color: @color-secondary;
}
.end-of-page {
  width: 100%;
  padding: @content-side-margin;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
